import { PostPublishingMethod } from 'types/Post';
import { PseudoPostType } from 'constants/post';
import { PseudoPostTypesUtils } from 'app/modules/posts/utils/pseudoPostType';

export type PostPublishingMethodProperties = {
  label: string;
  description: string;
  link?: string;
  isNew?: boolean;
};

const IG_PUBLISHING_METHODS_PROPERTIES: Record<
  PostPublishingMethod,
  Partial<Record<PseudoPostType, PostPublishingMethodProperties>>
> = {
  mobileApp: {
    [PseudoPostType.Story]: {
      label: 'Manual publishing',
      description: `Schedule the Story via our Kontentino app and you will receive a push notification 5 minutes before the scheduled time to post it manually. Enhance the Story with texts, stickers, music, and other options.`,
      link: 'https://intercom.help/kontentino/en/articles/7995181-scheduling-instagram-stories',
      isNew: false,
    },
  },
  direct: {
    [PseudoPostType.Story]: {
      label: 'Direct publishing',
      description: `Kontentino will publish your Story automatically. Restrictions apply as adding text, stickers, music, and other editing is not supported in this method.`,
      link: 'https://intercom.help/kontentino/en/articles/7995181-scheduling-instagram-stories',
      isNew: true,
    },
  },
};

const IG_DEFAULT_PUBLISHING_METHOD_PROPERTIES = {
  mobileApp: (pseudoPostType: PseudoPostType) => ({
    label: 'Manual publishing',
    description: `Schedule the ${PseudoPostTypesUtils.label[pseudoPostType]} via our Kontentino app and you will receive a push notification 5 minutes before the scheduled time to post it manually.`,
  }),
  direct: (pseudoPostType: PseudoPostType) => ({
    label: 'Direct publishing',
    description: `Kontentino will publish your ${PseudoPostTypesUtils.label[pseudoPostType]} automatically. `,
  }),
} satisfies Record<
  PostPublishingMethod,
  (pseudoPostType: PseudoPostType) => PostPublishingMethodProperties
>;

export const IGPostPublishingMethodUtils = {
  getProperties(
    method: PostPublishingMethod,
    pseudoType: PseudoPostType,
  ): PostPublishingMethodProperties {
    const specificProperties =
      IG_PUBLISHING_METHODS_PROPERTIES[method]?.[pseudoType];

    if (specificProperties) return specificProperties;

    return IG_DEFAULT_PUBLISHING_METHOD_PROPERTIES[method](pseudoType);
  },
  getOptionsEntries(pseudoType: PseudoPostType) {
    const publishingMethods: PostPublishingMethod[] = ['mobileApp', 'direct'];

    return publishingMethods.map(
      (method) =>
        [
          method,
          IGPostPublishingMethodUtils.getProperties(method, pseudoType),
        ] as const,
    );
  },
};
